import { type TranslationTree } from '@/i18n/types';

export const messages = {
  update: 'Atualizar',
  cancel: 'Cancelar',
  zoom: 'Zoom',
  rotation: 'Rotação',
  processError: 'Não foi possível processar ou enviar a imagem. Tente novamente.',
} satisfies TranslationTree;
